import EventEmitter from 'methods/eventEmitter';
import {ajaxGetData} from 'methods/ajaxData';

import AuthorizationModal from './modals/authorization';
import ForgotModal from './modals/forgot';
import RegistrationModal from './modals/registration';
import SuccessModal from './modals/success';
import ChangePasswordModal from './modals/changePassword';

function Modals() {
    // наследуемся
    EventEmitter.call(this);

    this._events = {
        getModal: function(id) {
            if (typeof this._modals[id] === 'undefined') {
                return false;
            }

            return this._modals[id];
        },
        openModal: function(modal_id) {
            // закрываем пред модалки
            ModalLayers.closeActiveModal();

            let modal = this._events.getModal(modal_id);
            if (modal) {
                modal.open();
            }
        },
    }

    // делаем bind this
    for(let fn in this._events) {
        if (typeof this._events[fn] === 'function') {
            this._events[fn] = this._events[fn].bind(this);
            continue;
        }
    }

    document.addEventListener('click', (e) => {
        // открытие модалки
        if (e.target.dataset.modal_id) {
            return this._events.openModal(e.target.dataset.modal_id);
        }
    });

    this.init = function() {
        this._modals = {
            'authorization': new AuthorizationModal(),
            'forgot': new ForgotModal(),
            'registration': new RegistrationModal(),
        };

        // модалка успешной регистрации
        this._modals.registration.on('success', (email) => {
            this._modals['successRegistration'] = new SuccessModal(`<div class="header-title">Вы успешно зарегистрировались!</div><div class="message js-message">Доступы отправлены на почту ${email}</div>`);
            this._events.openModal('successRegistration');
        });

        // модалка восстановление пароля
        this._modals.forgot.on('success', (email) => {
            this._modals['successRegistration'] = new SuccessModal(`<div class="header-title">Восстановление пароля</div><div class="message">На почту ${email} была отправлена ссылка для смены пароля</div>`,
                `<span class="link gray" data-modal_id="authorization">Войти</span><span class="link gray" data-modal_id="registration">Зарегистрироваться</span>`);
            this._events.openModal('successRegistration');
        });

        // модалка восстановления пароля
        if (location.hash) {
            let data = '';

            try {
                data = atob(location.hash.replace(/\/$/, '').replace(/^#/, ''));
            } catch(e) {
                // ignore
            }

            if (data.indexOf('{"') === 0) {
                data = JSON.parse(data);

                if (data.form === 'changePassword') {
                    this._modals['changePassword'] = new ChangePasswordModal(data);
                    this._events.openModal('changePassword');

                    this._modals['changePassword'].on('success', (redirect) => {
                        document.location.href = redirect;
                    });
                }
            }
        }
    }
    this.init();
}

export default Modals;
